import { InspirationalTemplate } from '../domain/entities/inspirationalTemplate';
import { useInitialState } from '../contexts/InitialStateContext';

export const useInspirationalTemplates = (): InspirationalTemplate[] => {
  const { inspirationalTemplates } = useInitialState();
  return inspirationalTemplates;
};
